var map = {
	"./hero/map": [
		8271,
		271
	],
	"./joyland/map": [
		3996,
		996
	],
	"./little-donkey/map": [
		9804,
		804
	],
	"./luca/map": [
		8247,
		247
	],
	"./magnolia-point/map": [
		2798,
		798
	],
	"./pihakis/map": [
		1674,
		674
	],
	"./psito/map": [
		7486,
		486
	],
	"./rodney-scotts/map": [
		60,
		60
	],
	"./tasty-town/map": [
		8927,
		927
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2501;
module.exports = webpackAsyncContext;